import api from "../api";

// Share habit (supports multiple users)
export const shareHabit = async (habitId, sharedWithIds) => {
  // Ensure sharedWithIds is an array
  const ids = Array.isArray(sharedWithIds) ? sharedWithIds : [sharedWithIds];
  return await api.getApi().post(`/habits/${habitId}/share`, { sharedWithIds: ids });
};

// Get habits shared with me
export const getSharedHabits = async (status) => {
  return await api.getApi().get("/habits/shared-with-me", {
    params: status ? { status } : {},
  });
};

// Accept/Decline shared habit
export const acceptSharedHabit = async (sharedId) => {
  return await api.getApi().post(`/habits/shared/${sharedId}/accept`);
};

export const declineSharedHabit = async (sharedId) => {
  return await api.getApi().post(`/habits/shared/${sharedId}/decline`);
};

// Get users habit is shared with
export const getSharedUsers = async (habitId) => {
  return await api.getApi().get(`/habits/${habitId}/shared-users`);
};
